import React from 'react';

import Reveal from '@/widgets/ServiceLanding/Reveal';
import SectionHeading from '@/widgets/ServiceLanding/SectionHeading';

import classes from './index.module.css';
import { BenefitsProps } from './models';

const Benefits = ({ badge, title, subtitle, items, sectionClassName = 'bg-gradient-to-b from-white to-sky-50/60 py-16 md:py-24' }: BenefitsProps) => {
    return (
        <section className={sectionClassName}>
            <div className='desktop-width px-4'>
                <SectionHeading badge={badge} title={title} subtitle={subtitle} />

                <ul className='m-0 grid list-none gap-4 p-0 sm:grid-cols-2 md:gap-6 xl:grid-cols-3'>
                    {items.map((benefit, index) => (
                        <li key={benefit.title} className='h-full'>
                            <Reveal delay={(index % 3) * 90 + Math.floor(index / 3) * 60} className='h-full'>
                                <div
                                    className={`${classes.card} flex h-full cursor-default flex-col items-center gap-4 rounded-lg p-6 text-center
                                    sm:items-start sm:text-right`}>
                                    <span className={`${classes.iconTile} flex h-14 w-14 items-center justify-center rounded-lg text-white`}>
                                        <benefit.icon size={28} variant='Bold' color='currentColor' aria-hidden />
                                    </span>
                                    <div className='space-y-2'>
                                        <h3 className='text-base font-black text-blackHighEmphasis md:text-lg'>{benefit.title}</h3>
                                        <p className='text-sm leading-7 text-blackMediumEmphasis'>{benefit.description}</p>
                                    </div>
                                </div>
                            </Reveal>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
};

export default Benefits;
